const config = {
  uid: 'e91dff60-ba99-11e8-9686-ernofinwe7',
  viewer: {
    autoPause: false,
    autoResume: false,
  },
  history: {
    enabled: false,
  },
  controllers: {
    enabled: true,
    instances: [
      {
        uid: 'controller-0',
        type: 'pointer',
        enabled: true,
        options: {
          fullscreen: false,
          orientation: {
            drag: true,
            invert: true,
            damping: 0.1,
            hardness: 0.99,
            velocityMax: 200,
          },
          zoom: {
            hardness: 5,
            invert: false,
          },
        },
      },
    ],
  },
  camera: {
    fov: {
      default: 90,
    },
    keep: true,
  },
  actions: null,
  story: {
    uid: 'e91dff60-ba99-11e8-9686-ernofinwe7',
    name: 'name',
    slug: 'slug',
    scenes: [
      {
        uid: 'scene-0',
        slug: 'slug-0',
        name: 'scene 0',
        media: {
          options: {
            loop: false,
            autoPlay: true,
          },
          uid: 'media-0',
          type: 'video',
          source: {
            format: 'equi',
            streaming: 'dash',
          },
        },
        hotspots: [
        ],
      },
    ],
  },
};

export { config as default };
